export function getItemId(itemType: string, item: any): number | string {
    switch (itemType) {
      case 'location':
        return item.id;
      case 'voucher':
        return +item.voucherID;
      case 'wallet':
        return +item.purseID;
      case 'clickAndCollect':
        return +item.collectID;
      default:
        return +item.id; // Fallback to 'id' if no specific case is found
    }
  }